import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-error-button',
    templateUrl: './error-button.component.html',
    styleUrls: ['./error-button.component.scss'],
    standalone: false
})
export class ErrorButtonComponent implements OnInit {

  message = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) { }

  ngOnInit() {
    this.message = this.data.message;
  }

}
